/**
 * FakeIntersectionObserver
 *
 * Lies to browsers that do not support interaction observer.
 * Just does passthrough of props and says elements are visible.
 *
 * This class is aimed at implementation only inside <LazyRender />.
 * Correct behavior outside of the intended is not guaranteed.
 *
 * Disabling no-null rule in order to implement IntersectionObserver contract
 */
export class FakeIntersectionObserver {
    constructor(callback, options) {
        const t = options.threshold && Array.isArray(options.threshold) ?
            options.threshold :
            [options.threshold || .01];
        this.faked = true;
        this.thresholds = t;
        this.callback = callback;
        // eslint-disable-next-line no-null/no-null
        this.root = options.root || null;
        this.rootMargin = options.rootMargin || "";
    }
    disconnect() { }
    observe() {
        this.callback(this.takeRecords(), {});
    }
    takeRecords() {
        return [{
                isIntersecting: true,
                // eslint-disable-next-line no-null/no-null
                target: null
            }];
    }
    unobserve() { }
}
//# sourceMappingURL=FakeIntersectionObserver.js.map